import { useAuthStore } from "../Contexts/AuthContext";
import { isMockFidoToken } from "../Constants/webauthnMock";
import { dispatchAuthUnauthorized } from "../Services/authToken";

const logoutErrors = [];

export const useValidateErrorResponse = () => {
  // const { enqueueSnackbar } = useSnackbar();

  const validateError = (response) => {
    const { status, data } = response || {};

    if (status === 401) {
      const token = useAuthStore.getState().token;
      if (isMockFidoToken(token)) {
        return;
      }
      dispatchAuthUnauthorized();
      return;
    }

    const { errors } = data || {};

    if (errors?.length) {
      errors?.map((objError) => {
        if (logoutErrors.indexOf(objError.code) !== -1) {
          dispatchAuthUnauthorized();
        }
        // enqueueSnackbar(intl.get(`errors.${objError.code}`), {
        //   variant: "error",
        // });
      });
    }
  };

  return { validateError };
};
